import React, { useEffect, useRef, useState } from "react";
import LoaderBigTwo from "../../Shared/LoaderBigTwo/LoaderBigTwo";
import { DateRangePicker } from "react-date-range";
import { Link } from "react-router-dom";
import './AllJobAdmin.css'

const SubSentInvoice = () => {
  const [allTutors, setAllTutors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [AllReactDate, setAllReactDate] = useState([]);
  const [ReactStartDate, ReactSetStartDate] = useState(new Date());
  const [ReactEndDate, ReactSetEndDate] = useState(new Date());
  const [totalSalary, setTotalSalary] = useState(0);


  // https://tutor-tree-server-1.vercel.app/allTutors
  const fetchAllTutors = async () => {
    try {
      const response = await fetch(
        "https://tutor-tree-server-1.vercel.app/SentInvoiceStudentsData"
      );
      const data = await response.json();
      setAllTutors(data.reverse());
      setAllReactDate(data);
      const totalSalary = data.reduce((acc, teacher) => {
        // Convert teacher.salary to a number before adding it
        return acc + Number(teacher.salary || 0);
      }, 0);
      setTotalSalary(totalSalary);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Districts:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllTutors();
  }, []);

  ///////////////////////// AREA AND CITY /////////////////////////
  ////////////////////////////////////////////////////////////////
  const [districts, setDistricts] = useState([]);

  const fetchDistricts = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/allDistrict");
      const data = await response.json();
      setDistricts(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDistricts();
  }, []);

  const [Area, setArea] = useState([]);
  const fetchArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/allArea");
      const data = await response.json();
      setArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchArea();
  }, []);

  ////////////////////////////////// khulna and chittagong area start ///////////////////////////////
  const [KhulnaArea, setKhulnaArea] = useState([]);
  const fetchKhulnaArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/khulnaArea");
      const data = await response.json();
      setKhulnaArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchKhulnaArea();
  }, []);
  const [ChittagongArea, setChittagongArea] = useState([]);
  const fetchChittagongArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/ChittagongArea");
      const data = await response.json();
      setChittagongArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchChittagongArea();
  }, []);

  const [DhakaArea, setDhakaArea] = useState([]);
  const fetchDhakaArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/DhakaArea");
      const data = await response.json();
      setDhakaArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDhakaArea();
  }, []);
  ////////////////////////////////// khulna and chittagong area end   ///////////////////////////////

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedCategory, setCategory] = useState(null);

  const [selectedTutorGender, setTutorGender] = useState(null);
  const [selectedStudentGender, setStudentGender] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [filteredTutors, setFilteredTutors] = useState([]);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState("");
  const [classOptions, setClassOptions] = useState([]);

  //////////////// checkmark ///////////////

  const [checkedItems, setCheckedItems] = useState([]);

  console.log(checkedItems);
  const handleChange = (event) => {
    const label = event.target.nextSibling.htmlFor;
    if (event.target.checked) {
      // Add the label to the state if checked
      setCheckedItems((prevItems) => [...prevItems, label]);
    } else {
      // Remove the label from the state if unchecked
      setCheckedItems((prevItems) =>
        prevItems.filter((item) => item !== label)
      );
    }
  };

  const [checkedItemsTwo, setCheckedItemsTwo] = useState([]);

  const handleChangeTwo = (event) => {
    const label = event.target.nextSibling.htmlFor;
    if (event.target.checked) {
      // Add the label to the state if checked
      setCheckedItemsTwo((prevItems) => [...prevItems, label]);
    } else {
      // Remove the label from the state if unchecked
      setCheckedItemsTwo((prevItems) =>
        prevItems.filter((item) => item !== label)
      );
    }
  };

  const [checkedItemsThree, setCheckedItemsThree] = useState([]);

  const handleChangeThree = (event) => {
    const label = event.target.nextSibling.htmlFor;
    if (event.target.checked) {
      // Add the label to the state if checked
      setCheckedItemsThree((prevItems) => [...prevItems, label]);
    } else {
      // Remove the label from the state if unchecked
      setCheckedItemsThree((prevItems) =>
        prevItems.filter((item) => item !== label)
      );
    }
  };

  const [checkedItemsFour, setCheckedItemsFour] = useState([]);

  const handleChangeFour = (event) => {
    const label = event.target.nextSibling.htmlFor;
    if (event.target.checked) {
      // Add the label to the state if checked
      setCheckedItemsFour((prevItems) => [...prevItems, label]);
    } else {
      // Remove the label from the state if unchecked
      setCheckedItemsFour((prevItems) =>
        prevItems.filter((item) => item !== label)
      );
    }
  };
  const [showSearchButton, setShowSearchButton] = useState(true);
  const [filteredTutorsCount, setFilteredTutorsCount] = useState(0); // New state for storing the count

  const handleSearch = () => {
    const filteredData = allTutors.filter((teacher) => {
      // Convert teacher.jobId to a string for comparison
      const matchJobId =
        !selectedJobId || teacher.jobId === selectedJobId.toString();
      const matchTutorGender =
        !selectedTutorGender || teacher.tutorGender === selectedTutorGender;
      const matchTutorClass =
        !selectedOption || teacher.class === selectedOption;
      const matchStudentGender =
        !selectedStudentGender || teacher.gender === selectedStudentGender;
      // const matchCategory = !selectedCategory || teacher.category === selectedCategory;
      const matchDistrict =
        !selectedDistrict || teacher.city === selectedDistrict;
      const matchArea = !selectedArea || teacher.area === selectedArea;
      const matchCheckedItems =
        checkedItems.length === 0 ||
        checkedItems.some((item) => teacher.category?.includes(item));
      const matchCheckedClass =
        checkedItemsTwo.length === 0 ||
        checkedItemsTwo.some((item) => teacher.class?.includes(item));
      const matchCheckedDistrict =
        checkedItemsThree.length === 0 ||
        checkedItemsThree.some((item) => teacher.city?.includes(item));
      const matchCheckedArea =
        checkedItemsFour.length === 0 ||
        checkedItemsFour.some((item) => teacher.area?.includes(item));
      return (
        matchJobId &&
        matchTutorClass &&
        matchTutorGender &&
        matchStudentGender &&
        matchDistrict &&
        matchArea &&
        matchCheckedItems &&
        matchCheckedClass &&
        matchCheckedDistrict &&
        matchCheckedArea
      );
    });

    setFilteredTutors(filteredData);
    const totalSalary = filteredData.reduce((acc, teacher) => {
        // Convert teacher.salary to a number before adding it
        return acc + Number(teacher.salary || 0);
      }, 0);    
    setTotalSalary(totalSalary);
    setFilteredTutorsCount(filteredData.length);
    setSearchPerformed(true);
    setIsOpen(false);
    setShowSearchButton(false);
  };

  const displayData = searchPerformed ? filteredTutors : allTutors;

  const handleSelect = (date) => {
    let startDate = new Date(date.selection.startDate);
    let endDate = new Date(date.selection.endDate);

    // If the start and end dates are the same, adjust them to cover the entire day
    if (startDate.toDateString() === endDate.toDateString()) {
      startDate.setHours(0, 0, 0, 0); // Set start date to beginning of the day
      endDate.setHours(23, 59, 59, 999); // Set end date to end of the day
    }

    // Convert date strings in your data to Date objects and filter
    let filtered = AllReactDate.filter((product) => {
      let productDate = new Date(product.postedDate);
      return productDate >= startDate && productDate <= endDate;
    });

    ReactSetStartDate(startDate);
    ReactSetEndDate(endDate);
    setAllTutors(filtered);
    const totalSalary = filtered.reduce((acc, teacher) => acc + (teacher.salary || 0), 0);
    setTotalSalary(totalSalary);
    setFilteredTutorsCount(filtered.length);
    console.log(startDate, endDate);
  };

  const selectionRange = {
    startDate: ReactStartDate,
    endDate: ReactEndDate,
    key: "selection",
  };

  const [isOpenDrop, setIsOpenDrop] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdownTwo = () => {
    setIsOpenDrop(!isOpenDrop);
  };

  const closeDropdown = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpenDrop(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeDropdown);

    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, []);

  const handleClear = () => {

    ReactSetStartDate(null);
    ReactSetEndDate(null);
    setAllTutors(AllReactDate); // Reset to the original data
  
    // Reset total salary to the sum of all tutors' salaries in AllReactDate
    const totalSalaryReset = AllReactDate.reduce((acc, tutor) => acc + Number(tutor.salary || 0), 0);
    setTotalSalary(totalSalaryReset);
  
    // Clear search-related states
    setFilteredTutors([]);
    setFilteredTutorsCount(0); // Assuming you have this state for tracking count
    setSearchPerformed(false);
    setCheckedItems([]);
    setCheckedItemsTwo([]);
    setCheckedItemsThree([]);
    setCheckedItemsFour([]);
  
    // Resetting any selected filters if you have state for them
    setSelectedJobId(null);
    setSelectedOption(null);
    setSelectedDistrict(null);
    setSelectedArea(null);
  
    setShowSearchButton(true);
  };
  

  //////////////////////// PAGINATION ////////////////////

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Set the number of items to display per page
  const maxPageButtons = 5; // Set the maximum number of pagination buttons to display

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = displayData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPageCount = Math.ceil(displayData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const generatePaginationButtons = () => {
    const pageButtons = [];
    let startPage = 1;
    let endPage = totalPageCount;

    if (totalPageCount > maxPageButtons) {
      if (currentPage <= Math.ceil(maxPageButtons / 2)) {
        endPage = maxPageButtons;
      } else if (
        currentPage >
        totalPageCount - Math.floor(maxPageButtons / 2)
      ) {
        startPage = totalPageCount - maxPageButtons + 1;
      } else {
        startPage = currentPage - Math.floor(maxPageButtons / 2);
        endPage = currentPage + Math.floor(maxPageButtons / 2);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <li key={i}>
          <button
            onClick={() => handlePageChange(i)}
            className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
              currentPage === i ? "text-blue-600 bg-blue-50" : ""
            }`}
          >
            {i}
          </button>
        </li>
      );
    }

    return pageButtons;
  };
  const classMapping = {
    "Pre-Schooling": "Pre-Schooling",
    Play: "Play",
    Nursery: "Nursery",
    KG: "KG",
    BM1: "Class 1",
    BM2: "Class 2",
    BM3: "Class 3",
    BM4: "Class 4",
    BM5: "Class 5",
    BM6: "Class 6",
    BM7: "Class 7",
    BM8: "Class 8",
    BM9: "Class 9",
    BM10: "Class 10",
    "BMHSC-1stYear": "HSC-1st Year",
    "BMHSC-2stYear": "HSC-2nd Year",
    EV1: "Class 1",
    EV2: "Class 2",
    EV3: "Class 3",
    EV4: "Class 4",
    EV5: "Class 5",
    EV6: "Class 6",
    EV7: "Class 7",
    EV8: "Class 8",
    EV9: "Class 9",
    EV10: "Class 10",
    "EVHSC-1stYear": "HSC-1st Year",
    "EVHSC-2stYear": "HSC-2nd Year",
    EM1: "Class 1",
    EM2: "Class 2",
    EM3: "Class 3",
    EM4: "Class 4",
    EM5: "Class 5",
    EM6: "Class 6",
    EM7: "Class 7",
    EM8: "Class 8",
    EM9: "Class 9",
    OLevel: "OLevel",
    ALevelAS: "A Level (AS)",
    ALevelA2: "A Level (A2)",
    "EMHSC-2stYear": "HSC-2nd Year",
    Alim1: "Class 1",
    Alim2: "Class 2",
    Alim3: "Class 3",
    Alim4: "Class 4",
    Alim5: "Class 5",
    Alim6: "Class 6",
    Alim7: "Class 7",
    Alim8: "Class 8",
    Alim9: "Class 9",
    Alim10: "Class 10",
    "Alim-1stYear": "Alim-1st Year",
    "Alim-2stYear": "Alim-2nd Year",
    IslamicStudies: "Islamic Studies",
    HinduismStudies: "Hinduism Studies",
    BuddhismStudies: "Buddhism Studies",
    ChristianityStudies: "Christianity Studies",
    SchoolAdmissionTest: "School Admission Test",
    PublicUniversityAdmissionTest: "Public University Admission Test",
    PrivateUniversityAdmissionTest: "Private University Admission Test",
    MedicalCollegeAdmissionTest: "Medical College Admission Test",
    EngineeringUniversityAdmissionTest: "Engineering University Admission Test",
    Arts: "Arts",
    Music: "Music",
    InstrumentalMusic: "Instrumental Music",
    Dance: "Dance",
    Crafting: "Crafting",
    Recitation: "Recitation",
    TestPreparation: "Test Preparation",
    IELTS: "IELTS",
    TOEFL: "TOEFL",
    GRE: "GRE",
    GMAT: "GMAT",
    SAT: "SAT",
    GED: "GED",
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleRemove = (itemToRemove) => {
    setCheckedItems((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
    // Uncheck the checkbox
    const checkbox = document.getElementById(itemToRemove);
    if (checkbox) {
      checkbox.checked = false;
    }
  };

  const formattedOutput = checkedItems.map((item) => (
    <div
      className="flex flex-row justify-between pl-2 items-center m-2 bg-orange-100 h-7  rounded-3xl"
      key={item}
    >
      {item}
      <button
        onClick={() => handleRemove(item)}
        className="w-7 h-7 ml-1 bg-orange-500 hover:bg-orange-600 text-white flex justify-center items-center rounded-full"
      >
        X
      </button>
    </div>
  ));

  /////////////////// remove two ///////
  const handleRemoveTwo = (itemToRemove) => {
    setCheckedItemsTwo((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
    // Uncheck the checkbox
    const checkbox = document.getElementById(itemToRemove);
    if (checkbox) {
      checkbox.checked = false;
    }
  };

  const formattedOutputTwo = checkedItemsTwo.map((item) => (
    <div
      className="flex flex-row justify-between pl-2 items-center m-2 bg-orange-100 h-7  rounded-3xl"
      key={item}
    >
      {classMapping[item] || item}
      <button
        onClick={() => handleRemoveTwo(item)}
        className="w-7 h-7 ml-1 bg-orange-500 hover:bg-orange-600 text-white flex justify-center items-center rounded-full"
      >
        X
      </button>
    </div>
  ));

  ////////////////// remove three ///////////
  const handleRemoveThree = (itemToRemove) => {
    setCheckedItemsThree((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
    // Uncheck the checkbox
    const checkbox = document.getElementById(itemToRemove);
    if (checkbox) {
      checkbox.checked = false;
    }
  };

  const formattedOutputThree = checkedItemsThree.map((item) => (
    <div
      className="flex flex-row justify-between pl-2 items-center m-2 bg-orange-100 h-7  rounded-3xl"
      key={item}
    >
      {item}
      <button
        onClick={() => handleRemoveThree(item)}
        className="w-7 h-7 ml-1 bg-orange-500 hover:bg-orange-600 text-white flex justify-center items-center rounded-full"
      >
        X
      </button>
    </div>
  ));

  ////////////////// remove Four ///////////
  const handleRemoveFour = (itemToRemove) => {
    setCheckedItemsFour((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
    // Uncheck the checkbox
    const checkbox = document.getElementById(itemToRemove);
    if (checkbox) {
      checkbox.checked = false;
    }
  };

  const formattedOutputFour = checkedItemsFour.map((item) => (
    <div
      className="flex flex-row justify-between py-1 pl-2 items-center m-2 bg-orange-100   rounded-3xl"
      key={item}
    >
      {item}
      <button
        onClick={() => handleRemoveFour(item)}
        className="w-7 h-7 ml-1 bg-orange-500 hover:bg-orange-600 text-white flex justify-center items-center rounded-full"
      >
        X
      </button>
    </div>
  ));


  return (
    <div>
      <div className="sticky top-0 bg-white border-t-2 border-orange-500">
        <div className="w-full b lg:h-20 sm:h-24 flex lg:items-center lg:flex-row sm:flex-col justify-between border-b-2 sticky top-0 border-orange-100">
          <div className="h-10 flex justify-center items-center">
            <div>
              <img
                src="https://i.ibb.co/3FwpMnc/Group-1000004006.png"
                alt=""
              ></img>
            </div>
            <div className="ml-3">
              <h1 className="headerText">
                {searchPerformed
                  ? `${filteredTutorsCount}`
                  : `${allTutors.length}`}{" "}
                jobs found
              </h1>
            </div>
            <div className="lg:ml-10 lg:flex lg:justify-center lg:items-center sm:hidden">
              <input
                type="text"
                id="jobIdInput"
                value={selectedJobId}
                class="idInput rounded-lg block w-48  h-10 p-2.5"
                placeholder="Search by id"
                required
                onChange={(e) => setSelectedJobId(e.target.value)}
              />
              {showSearchButton ? (
                <button
                  className="bg-orange-400 hover:bg-orange-500  w-10 h-10 flex justify-center items-center rounded-r-md"
                  onClick={handleSearch}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.35286 0C2.39891 0 0 2.39891 0 5.35286C0 8.30682 2.39891 10.7057 5.35286 10.7057C8.30682 10.7057 10.7057 8.30682 10.7057 5.35286C10.7057 2.39891 8.30682 0 5.35286 0ZM5.35286 0.823517C7.85306 0.823517 9.88221 2.85266 9.88221 5.35286C9.88221 7.85306 7.85306 9.88221 5.35286 9.88221C2.85266 9.88221 0.823517 7.85306 0.823517 5.35286C0.823517 2.85266 2.85266 0.823517 5.35286 0.823517Z"
                      fill="#FFFFFF"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.8794 13.2963L9.13675 8.55452C8.97616 8.39394 8.71511 8.39394 8.55452 8.55452C8.39394 8.71511 8.39394 8.97616 8.55452 9.13675L13.2963 13.8794C13.4577 14.04 13.718 14.04 13.8794 13.8794C14.04 13.718 14.04 13.4577 13.8794 13.2963Z"
                      fill="#FFFFFF"
                    />
                  </svg>
                </button>
              ) : (
                <button
                  className="bg-orange-400 hover:bg-orange-500  w-10 h-10 flex justify-center items-center rounded-r-md"
                  onClick={handleClear}
                >
                  <svg
                    class="h-5 w-5 text-gray-200"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    {" "}
                    <line x1="18" y1="6" x2="6" y2="18" />{" "}
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>{" "}
                  :
                </button>
              )}
            </div>
          </div>
          <div className="sm:my-3 sm:flex sm:flex-row">
            <div className="sm:ml-10 sm:mr-3 flex justify-center items-center lg:hidden">
              <input
                type="text"
                id="jobIdInput"
                value={selectedJobId}
                class="idInput rounded-lg block lg:w-48 sm:w-full  h-10 p-2.5"
                placeholder="Search by id"
                required
                onChange={(e) => setSelectedJobId(e.target.value)}
              />
              {showSearchButton ? (
                <button
                  className="bg-orange-400 hover:bg-orange-500  w-10 h-10 flex justify-center items-center rounded-r-md"
                  onClick={handleSearch}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.35286 0C2.39891 0 0 2.39891 0 5.35286C0 8.30682 2.39891 10.7057 5.35286 10.7057C8.30682 10.7057 10.7057 8.30682 10.7057 5.35286C10.7057 2.39891 8.30682 0 5.35286 0ZM5.35286 0.823517C7.85306 0.823517 9.88221 2.85266 9.88221 5.35286C9.88221 7.85306 7.85306 9.88221 5.35286 9.88221C2.85266 9.88221 0.823517 7.85306 0.823517 5.35286C0.823517 2.85266 2.85266 0.823517 5.35286 0.823517Z"
                      fill="#FFFFFF"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.8794 13.2963L9.13675 8.55452C8.97616 8.39394 8.71511 8.39394 8.55452 8.55452C8.39394 8.71511 8.39394 8.97616 8.55452 9.13675L13.2963 13.8794C13.4577 14.04 13.718 14.04 13.8794 13.8794C14.04 13.718 14.04 13.4577 13.8794 13.2963Z"
                      fill="#FFFFFF"
                    />
                  </svg>
                </button>
              ) : (
                <button
                  className="bg-orange-400 hover:bg-orange-500  w-10 h-10 flex justify-center items-center rounded-r-md"
                  onClick={handleClear}
                >
                  <svg
                    class="h-5 w-5 text-gray-200"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    {" "}
                    <line x1="18" y1="6" x2="6" y2="18" />{" "}
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>{" "}
                  :
                </button>
              )}
            </div>
            <div className="sm:flex lg:inline-flex sm:justify-end">
              <button
                onClick={toggleDropdown}
                className="filterButton lg:w-32 sm:w-24 h-10 mr-5 hover:bg-orange-700 transition duration-300 ease-in-out "
              >
                {isOpen ? (
                  <svg
                    class="h-5 w-5 text-gray-200"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    {" "}
                    <line x1="18" y1="6" x2="6" y2="18" />{" "}
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="14"
                    viewBox="0 0 16 14"
                    fill="none"
                  >
                    <path
                      d="M15.1447 0.263987C15.0687 0.102808 14.9065 0 14.7283 0H0.460361C0.282181 0 0.12002 0.102808 0.0439732 0.263987C-0.0320126 0.425165 -0.00819801 0.615682 0.105167 0.753169L5.58996 7.40555V13.5397C5.58996 13.6989 5.67227 13.8469 5.80755 13.9308C5.88169 13.9768 5.96584 14 6.05029 14C6.12008 14 6.19011 13.9841 6.25468 13.9521L9.33635 12.4247C9.49292 12.3472 9.59199 12.1876 9.59223 12.0129L9.59825 7.40574L15.0833 0.753107C15.1968 0.615682 15.2206 0.425104 15.1447 0.263987ZM8.78302 6.94737C8.7152 7.02961 8.67801 7.13291 8.67788 7.23959L8.67199 11.7265L6.51069 12.7977V7.2402C6.51069 7.13334 6.47356 7.0298 6.40555 6.94737L1.43652 0.920608H13.7521L8.78302 6.94737Z"
                      fill="white"
                    />
                  </svg>
                )}

                <span className="filterText ">
                  {" "}
                  {isOpen ? "Close" : "Filter"}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="w-full filterBackground lg:h-[380px] overflow-y-auto sm:h-[300px] shadow-xl sticky top-20 flex flex-col rounded px-10 py-5">
          <div className="w-full lg:mt-10 sm:mt-2 grid lg:grid-cols-2 sm:grid-cols-1 gap-5">
            <div ref={dropdownRef}>
              <button
                className="btnCalender transition duration-200 ease-in-out hover:bg-orange-600 w-full"
                onClick={toggleDropdownTwo}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M12.1953 1.09375H10.9375V0.4375C10.9375 0.195891 10.7416 0 10.5 0C10.2584 0 10.0625 0.195891 10.0625 0.4375V1.09375H3.9375V0.4375C3.9375 0.195891 3.74164 0 3.5 0C3.25836 0 3.0625 0.195891 3.0625 0.4375V1.09375H1.80469C0.809566 1.09375 0 1.90332 0 2.89844V12.1953C0 13.1904 0.809566 14 1.80469 14H12.1953C13.1904 14 14 13.1904 14 12.1953V2.89844C14 1.90332 13.1904 1.09375 12.1953 1.09375ZM1.80469 1.96875H3.0625V2.40625C3.0625 2.64786 3.25836 2.84375 3.5 2.84375C3.74164 2.84375 3.9375 2.64786 3.9375 2.40625V1.96875H10.0625V2.40625C10.0625 2.64786 10.2584 2.84375 10.5 2.84375C10.7416 2.84375 10.9375 2.64786 10.9375 2.40625V1.96875H12.1953C12.708 1.96875 13.125 2.3858 13.125 2.89844V3.9375H0.875V2.89844C0.875 2.3858 1.29205 1.96875 1.80469 1.96875ZM12.1953 13.125H1.80469C1.29205 13.125 0.875 12.708 0.875 12.1953V4.8125H13.125V12.1953C13.125 12.708 12.708 13.125 12.1953 13.125Z"
                    fill="white"
                  />
                </svg>{" "}
                Select Dates{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                >
                  <path
                    d="M0.166211 1.126L4.13877 5.76188C4.2028 5.83657 4.28223 5.89652 4.37161 5.93762C4.46099 5.97872 4.5582 6 4.65658 6C4.75496 6 4.85217 5.97872 4.94155 5.93762C5.03093 5.89652 5.11036 5.83657 5.17439 5.76188L9.14695 1.126C9.52607 0.683502 9.21175 0 8.62914 0H0.682888C0.100276 0 -0.21405 0.683502 0.166211 1.126Z"
                    fill="white"
                  />
                </svg>
              </button>
              {isOpenDrop && (
                <div className="">
                  {/* Dropdown content goes here */}
                  <ul className="mt-2 z-[1] absolute p-2 shadow  bg-base-100 rounded-box w-[470px]">
                    <DateRangePicker
                      ranges={[selectionRange]}
                      onChange={handleSelect}
                      className="w-[400px]"
                    />
                  </ul>
                </div>
              )}
            </div>
            <div className="flex flex-row justify-between gap-4 ">
              <div className="w-full">
                <select
                  className="select select-warning w-full max-w-xs"
                  onChange={(e) => setStudentGender(e.target.value)}
                >
                  <option disabled selected>
                    Student Gender
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="others">Others</option>

                  {/* Add more options as needed */}
                </select>
              </div>

              <div className="w-full">
                <select
                  className="select select-warning w-full max-w-xs"
                  onChange={(e) => setTutorGender(e.target.value)}
                >
                  <option disabled selected>
                    Tutor Gender Preference
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="others">Others</option>

                  {/* Add more options as needed */}
                </select>
              </div>
            </div>

            <details className="dropdown w-full">
              <summary className="w-full selectTextMain cursor-pointer flex overflow-y-scroll justify-between px-4 items-center lg:h-16 sm:h-12 bg-white border-2 border-orange-300 hover:border-orange-300 rounded-lg hover:bg-white text-black">
                {checkedItems.length > 0 ? (
                  formattedOutput
                ) : (
                  <h1 className="selectTextMain">Select Category</h1>
                )}
                <svg
                  id="Layer_1"
                  enable-background="new 0 0 128 128"
                  height="20"
                  viewBox="0 0 128 128"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="Down_Arrow_3_"
                    d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
                  />
                </svg>
              </summary>
              <ul className="p-2 shadow menu dropdown-content z-[1] bg-base-100 rounded-box w-full">
                <div className="form-checkbox">
                  <div className="flex flex-row justify-start items-center">
                    <input
                      type="checkbox"
                      id="BanglaVersion"
                      className="checked:bg-blue-600 checked:border-transparent"
                      onChange={handleChange}
                    />
                    <label
                      className="ml-4 selectTextMain"
                      htmlFor="BanglaVersion"
                    >
                      Bangla Version
                    </label>
                  </div>
                  <div className="flex flex-row justify-start items-center">
                    <input
                      type="checkbox"
                      id="EnglishVersion"
                      className="checked:bg-blue-600 checked:border-transparent"
                      onChange={handleChange}
                    />
                    <label
                      className="ml-4 selectTextMain"
                      htmlFor="EnglishVersion"
                    >
                      English Version
                    </label>
                  </div>
                  <div className="flex flex-row justify-start items-center">
                    <input
                      type="checkbox"
                      id="EnglishMedium"
                      className="checked:bg-blue-600 checked:border-transparent"
                      onChange={handleChange}
                    />
                    <label
                      className="ml-4 selectTextMain"
                      htmlFor="EnglishMedium"
                    >
                      English Medium
                    </label>
                  </div>
                  <div className="flex flex-row justify-start items-center">
                    <input
                      type="checkbox"
                      id="MadrasaMedium"
                      className="checked:bg-blue-600 checked:border-transparent"
                      onChange={handleChange}
                    />
                    <label
                      className="ml-4 selectTextMain"
                      htmlFor="MadrasaMedium"
                    >
                      Madrasa Medium
                    </label>
                  </div>
                  <div className="flex flex-row justify-start items-center">
                    <input
                      type="checkbox"
                      id="ReligiousStudies"
                      className="checked:bg-blue-600 checked:border-transparent"
                      onChange={handleChange}
                    />
                    <label
                      className="ml-4 selectTextMain"
                      htmlFor="ReligiousStudies"
                    >
                      Religious Studies
                    </label>
                  </div>
                  <div className="flex flex-row justify-start items-center">
                    <input
                      type="checkbox"
                      id="AdmissionTest"
                      className="checked:bg-blue-600 checked:border-transparent"
                      onChange={handleChange}
                    />
                    <label
                      className="ml-4 selectTextMain"
                      htmlFor="AdmissionTest"
                    >
                      Admission Test
                    </label>
                  </div>
                  <div className="flex flex-row justify-start items-center">
                    <input
                      type="checkbox"
                      id="Arts"
                      className="checked:bg-blue-600 checked:border-transparent"
                      onChange={handleChange}
                    />
                    <label className="ml-4 selectTextMain" htmlFor="Arts">
                      Arts
                    </label>
                  </div>
                  <div className="flex flex-row justify-start items-center">
                    <input
                      type="checkbox"
                      id="TestPreparation"
                      className="checked:bg-blue-600 checked:border-transparent"
                      onChange={handleChange}
                    />
                    <label
                      className="ml-4 selectTextMain"
                      htmlFor="TestPreparation"
                    >
                      Test Preparation
                    </label>
                  </div>
                </div>
              </ul>
            </details>
            {/* <div>Checked Items: {JSON.stringify(checkedItems)}</div> */}

            <details className="dropdown w-full">
              <summary className="w-full selectTextMain cursor-pointer flex justify-between px-4 items-center lg:h-16 sm:h-12 overflow-y-scroll bg-white border-2 border-orange-300 hover:border-orange-300 rounded-lg hover:bg-white text-black">
                {checkedItemsTwo.length > 0 ? (
                  formattedOutputTwo
                ) : (
                  <h1 className="selectTextMain">Select Class</h1>
                )}
                <svg
                  id="Layer_1"
                  enable-background="new 0 0 128 128"
                  height="20"
                  viewBox="0 0 128 128"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="Down_Arrow_3_"
                    d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
                  />
                </svg>
              </summary>
              <ul className="p-2 shadow menu h-56 overflow-y-scroll dropdown-content z-[1] bg-base-100 rounded-box w-full">
                {checkedItems.includes("BanglaVersion") && (
                  <div className="form-checkbox">
                    <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                      <h1 className="selectTextMain text-center">
                        Bangla Version
                      </h1>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Pre-Schooling"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="Pre-Schooling"
                      >
                        Pre-Schooling
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Play"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Play">
                        Play
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Nursery"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Nursery">
                        Nursery
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="KG"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="KG">
                        KG
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BM1"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="BM1">
                        Class 1
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BM2"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="BM2">
                        Class 2
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BM3"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="BM3">
                        Class 3
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BM4"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="BM4">
                        Class 4
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BM5"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="BM5">
                        Class 5
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BM6"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="BM6">
                        Class 6
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BM7"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="BM7">
                        Class 7
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BM8"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="BM8">
                        Class 8
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BM9"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="BM9">
                        Class 9
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BM10"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="BM10">
                        Class 10
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BMHSC-1stYear"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="BMHSC-1stYear"
                      >
                        HSC-1st Year
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BMHSC-2stYear"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="BMHSC-2stYear"
                      >
                        HSC-2nd Year
                      </label>
                    </div>
                  </div>
                )}
                {checkedItems.includes("EnglishVersion") && (
                  <div className="form-checkbox">
                    <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                      <h1 className="selectTextMain text-center">
                        English Version
                      </h1>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Pre-Schooling"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="Pre-Schooling"
                      >
                        Pre-Schooling
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Play"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Play">
                        Play
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Nursery"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Nursery">
                        Nursery
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="KG"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="KG">
                        KG
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EV1"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EV1">
                        Class 1
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EV2"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EV2">
                        Class 2
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EV3"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EV3">
                        Class 3
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EV4"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EV4">
                        Class 4
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EV5"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EV5">
                        Class 5
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EV6"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EV6">
                        Class 6
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EV7"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EV7">
                        Class 7
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EV8"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EV8">
                        Class 8
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EV9"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EV9">
                        Class 9
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EV10"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EV10">
                        Class 10
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EVHSC-1stYear"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="EVHSC-1stYear"
                      >
                        HSC-1st Year
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BMHSC-2stYear"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="BMHSC-2stYear"
                      >
                        HSC-1st Year
                      </label>
                    </div>
                  </div>
                )}
                {checkedItems.includes("EnglishMedium") && (
                  <div className="form-checkbox">
                    <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                      <h1 className="selectTextMain text-center">
                        English Medium
                      </h1>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Pre-Schooling"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="Pre-Schooling"
                      >
                        Pre-Schooling
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Play"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Play">
                        Play
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Nursery"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Nursery">
                        Nursery
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="KG"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="KG">
                        KG
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EM1"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EM1">
                        Class 1
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EM2"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EM2">
                        Class 2
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EM3"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EM3">
                        Class 3
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EM4"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EM4">
                        Class 4
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EM5"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EM5">
                        Class 5
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EM6"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EM6">
                        Class 6
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EM7"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EM7">
                        Class 7
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EM8"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EM8">
                        Class 8
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EM9"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="EM9">
                        Class 9
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="OLevel"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="OLevel">
                        O Level
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="ALevelAS"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="ALevelAS">
                        A Level (AS)
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="ALevelA2"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="ALevelA2">
                        A Level (A2)
                      </label>
                    </div>
                  </div>
                )}
                {checkedItems.includes("MadrasaMedium") && (
                  <div className="form-checkbox">
                    <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                      <h1 className="selectTextMain text-center">
                        Madrasa Medium
                      </h1>
                    </div>

                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Play"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Play">
                        Play
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Nursery"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Nursery">
                        Nursery
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="KG"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="KG">
                        KG
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim1"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Alim1">
                        Alim 1
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim2"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Alim2">
                        Alim 2
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim3"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Alim3">
                        Alim 3
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim4"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Alim4">
                        Alim 4
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim5"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Alim5">
                        Alim 5
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim6"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Alim6">
                        Alim 6
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim7"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Alim7">
                        Alim 7
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim8"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Alim8">
                        Alim 8
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim9"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Alim9">
                        Alim 9
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim 10"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Alim 10">
                        Alim 10
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim-1stYear"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="Alim-1stYear"
                      >
                        Alim-1st Year
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Alim-2nd Year"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="Alim-2nd Year"
                      >
                        Alim-2nd Year
                      </label>
                    </div>
                  </div>
                )}
                {checkedItems.includes("ReligiousStudies") && (
                  <div className="form-checkbox">
                    <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                      <h1 className="selectTextMain text-center">
                        Religious Studies
                      </h1>
                    </div>

                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="IslamicStudies"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="IslamicStudies"
                      >
                        Islamic Studies
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="HinduismStudies"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="HinduismStudies"
                      >
                        Hinduism Studies
                      </label>
                    </div>

                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="BuddhismStudies"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="BuddhismStudies"
                      >
                        Buddhism Studies
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="ChristianityStudies"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="ChristianityStudies"
                      >
                        Christianity Studies
                      </label>
                    </div>
                  </div>
                )}
                {checkedItems.includes("AdmissionTest") && (
                  <div className="form-checkbox">
                    <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                      <h1 className="selectTextMain text-center">
                        AdmissionTest
                      </h1>
                    </div>

                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="SchoolAdmissionTest"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="SchoolAdmissionTest"
                      >
                        School Admission Test
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="PublicUniversityAdmissionTest"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="PublicUniversityAdmissionTest"
                      >
                        Public University AdmissionTest
                      </label>
                    </div>

                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="PrivateUniversityAdmissionTest"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="PrivateUniversityAdmissionTest"
                      >
                        Private University AdmissionTest
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="MedicalCollegeAdmissionTest"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="MedicalCollegeAdmissionTest"
                      >
                        Medical College AdmissionTest
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="EngineeringUniversityAdmissionTest"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="EngineeringUniversityAdmissionTest"
                      >
                        Engineering University AdmissionTest
                      </label>
                    </div>
                  </div>
                )}
                {checkedItems.includes("Arts") && (
                  <div className="form-checkbox">
                    <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                      <h1 className="selectTextMain text-center">Arts</h1>
                    </div>

                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Handwriting"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="Handwriting"
                      >
                        Handwriting
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Music"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Music">
                        Music
                      </label>
                    </div>

                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="InstrumentalMusic"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="InstrumentalMusic"
                      >
                        InstrumentalMusic
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Dance"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Dance">
                        Dance
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Crafting"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="Crafting">
                        Crafting
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="Recitation"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor="Recitation"
                      >
                        Recitation
                      </label>
                    </div>
                  </div>
                )}
                {checkedItems.includes("TestPreparation") && (
                  <div className="form-checkbox">
                    <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                      <h1 className="selectTextMain text-center">
                        Test Preparation
                      </h1>
                    </div>

                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="IELTS"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="IELTS">
                        IELTS
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="TOEFL"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="TOEFL">
                        TOEFL
                      </label>
                    </div>

                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="GRE"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="GRE">
                        GRE
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="GMAT"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="GMAT">
                        GMAT
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="SAT"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="SAT">
                        SAT
                      </label>
                    </div>
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id="GED"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeTwo}
                      />
                      <label className="ml-4 selectTextMain" htmlFor="GED">
                        GED
                      </label>
                    </div>
                  </div>
                )}
              </ul>
            </details>

            {/* district area */}
            {/* district area */}
            {/* district area */}

            <details className="dropdown w-full">
              <summary className="w-full selectTextMain overflow-y-scroll lg:h-16 sm:h-12 cursor-pointer flex justify-between px-4 items-center bg-white border-2 border-orange-300 hover:border-orange-300 rounded-lg hover:bg-white text-black">
                {checkedItemsThree.length > 0 ? (
                  formattedOutputThree
                ) : (
                  <h1 className="selectTextMain">Select City</h1>
                )}
                <svg
                  id="Layer_1"
                  enable-background="new 0 0 128 128"
                  height="20"
                  viewBox="0 0 128 128"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="Down_Arrow_3_"
                    d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
                  />
                </svg>
              </summary>
              <ul className="p-2 shadow menu dropdown-content z-[1] bg-base-100 rounded-box w-full">
                {districts.map((dis) => (
                  <div className="form-checkbox">
                    <div className="flex flex-row justify-start items-center">
                      <input
                        type="checkbox"
                        id={dis.district}
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={handleChangeThree}
                      />
                      <label
                        className="ml-4 selectTextMain"
                        htmlFor={dis.district}
                      >
                        {dis.district}
                      </label>
                    </div>
                  </div>
                ))}
              </ul>
            </details>
            {/* <div>Checked Items: {JSON.stringify(checkedItemsThree)}</div> */}

            <details className="dropdown w-full">
              <summary className="w-full selectTextMain overflow-y-scroll  cursor-pointer  flex justify-between px-4 items-center lg:h-16 sm:h-12 bg-white border-2 border-orange-300 hover:border-orange-300 rounded-lg hover:bg-white text-black">
                {checkedItemsFour.length > 0 ? (
                  formattedOutputFour
                ) : (
                  <h1 className="selectTextMain">Select Area</h1>
                )}
                <svg
                  id="Layer_1"
                  enable-background="new 0 0 128 128"
                  height="20"
                  viewBox="0 0 128 128"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="Down_Arrow_3_"
                    d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
                  />
                </svg>
              </summary>
              <ul className="p-2 shadow menu h-56 overflow-y-scroll dropdown-content z-[1] bg-base-100 rounded-box w-full">
                {checkedItemsThree.includes("Chittagong") && (
                  <div className="form-checkbox">
                    {ChittagongArea.map((area) => (
                      <div className="form-checkbox">
                        <div className="flex flex-row justify-start items-center">
                          <input
                            type="checkbox"
                            id={area.district}
                            className="checked:bg-blue-600 checked:border-transparent"
                            onChange={handleChangeFour}
                          />
                          <label
                            className="ml-4 selectTextMain"
                            htmlFor={area.area}
                          >
                            {area.area}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {checkedItemsThree.includes("Khulna") && (
                  <div className="form-checkbox">
                    {KhulnaArea.map((area) => (
                      <div className="form-checkbox">
                        <div className="flex flex-row justify-start items-center">
                          <input
                            type="checkbox"
                            id={area.district}
                            className="checked:bg-blue-600 checked:border-transparent"
                            onChange={handleChangeFour}
                          />
                          <label
                            className="ml-4 selectTextMain"
                            htmlFor={area.area}
                          >
                            {area.area}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {checkedItemsThree.includes("Dhaka") && (
                  <div className="form-checkbox">
                    {DhakaArea.map((area) => (
                      <div className="form-checkbox">
                        <div className="flex flex-row justify-start items-center">
                          <input
                            type="checkbox"
                            id={area.district}
                            className="checked:bg-blue-600 checked:border-transparent"
                            onChange={handleChangeFour}
                          />
                          <label
                            className="ml-4 selectTextMain"
                            htmlFor={area.area}
                          >
                            {area.area}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </ul>
            </details>
            <div className="mt-5">
              <button className="BtnSrcFour" onClick={handleSearch}>
                Apply
              </button>
              <button className="BtnClearFour ml-5" onClick={handleClear}>
                Clear
              </button>
            </div>
          </div>
        </div>
      )}

      <div>
        <div>
          {loading ? (
            <div className="flex justify-center items-center ">
              <LoaderBigTwo></LoaderBigTwo>
            </div>
          ) : (
            <div>
              <div class=" overflow-x-auto">
                <table class="w-full text-sm text-left text-gray-200 dark:text-gray-400">
                  <thead class="border-4 border-gray-300">
                    <tr>
                      <th
                        scope="col"
                        class="px-6 py-3 w-full border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Job Id</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 w-full border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Guardian Name</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Student Gender</h1>
                      </th>

                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Hire Date</h1>
                      </th>

                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Publish Date</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText ">Class</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Category</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-16 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Subject</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Payment Refunded</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Days/Week</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Pending Payment</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">City</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Paid</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Location</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Tutor Gender</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Salary</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Guardian Number</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Cancellation Reason</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Start Date</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Cancellation Date</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 border-r-4 border-gray-200"
                      >
                        <h1 className="TableHeaderText">Status</h1>
                      </th>
                    </tr>
                  </thead>
                  {currentItems.map((all, index) => (
                    <tbody
                      key={index}
                      className="w-full text-sm text-left text-gray-500 dark:text-gray-400"
                    >
                      <tr class="bg-white dark:bg-gray-800">
                        <th
                          scope="row"
                          class="px-2 border-l-4 border-r-4 border-b border-gray-200 w-full tableBodyText dark:text-white"
                        >
                          {all.jobId}
                        </th>
                        <th
                          scope="row"
                          class="px-2 border-l-4 border-r-4 border-b border-gray-200 w-full tableBodyText dark:text-white"
                        >
                          {all.name} {all.posterName}
                        </th>
                        <th
                          scope="row"
                          class="px-6 py-4  border-r-4 border-b border-gray-200 tableBodyText dark:text-white"
                        >
                          {all.gender}
                        </th>
                        <td class="px-2 py-4 border-r-4 border-b border-gray-200 tableBodyText ">
                        {new Date(all.joiningDate).toLocaleDateString("en-GB")}
                        </td>
                        <td class="px-2 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                        {new Date(all.publishNewDate2).toLocaleDateString("en-GB")}
                        </td>
                        <td class="px-4 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                        {classMapping[all.class] || all.class}
                        </td>
                        <td class="px-2 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.category}
                        </td>
                        <td class="px-1 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                        {all.requiredSubject1} {all.requiredSubject2 ? "," : ""}{" "}
                        {all.requiredSubject2} {all.requiredSubject3 ? "," : ""}{" "}
                        {all.requiredSubject3} {all.requiredSubject4 ? "," : ""}{" "}
                        {all.requiredSubject4} {all.requiredSubject5 ? "," : ""}{" "}
                        {all.requiredSubject5}
                        </td>
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.EndDate}
                        </td>
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.EndDate}
                        </td>
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.EndDate}
                        </td>
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.city}
                        </td>
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          
                        </td>
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                        {all.area}
                        </td>
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.tutorGender}
                        </td>
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.salary}
                        </td>
                        <td class="px-2 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.posterPhone}
                        </td>
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.reason}
                        </td>
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.EndDate}
                        </td>
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.EndDate}
                        </td> 
                        <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                          {all.leads}
                        </td> 
                      </tr>
                    </tbody>
                  ))}
                   <thead class="border-t-4 border-gray-300">
                    <tr>
                      <th
                        scope="col"
                        class="px-6 py-3 w-full "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 w-full "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>

                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>

                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-16 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-3 "
                      >
                    <h1 className="TableHeaderTextTotal">Total Salary </h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                        <h1 className="TableHeaderTextTotal">{totalSalary}</h1>
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 "
                      >
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>

              <div className="flex items-center justify-center mt-10">
                <nav aria-label="Page navigation example">
                  <ul className="inline-flex -space-x-px text-sm">
                    <li>
                      <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        className={`flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                          currentPage === 1
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Previous
                      </button>
                    </li>
                    {generatePaginationButtons()}
                    <li>
                      <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover-bg-gray-100 hover-text-gray-700 dark-bg-gray-800 dark-border-gray-700 dark-text-gray-400 dark-hover-bg-gray-700 dark-hover-text-white ${
                          currentPage === totalPageCount
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubSentInvoice;
